import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/ladderManage',
  redirect: 'noredirect',
  name: 'ladderManage',
  component: Layout,
  children: [
    {
      path: 'ladderManage',
      component: () => import('@/views/ladderManage/index.vue'),
      name: 'ladderManage',
      meta: {
        title: '阶段管理',
        icon: 'equiptype',
        requireAuth: true
      }
    },
    {
      path: 'topicEndManage',
      component: () => import('@/views/topicEndManage/index.vue'),
      name: 'topicEndManage',
      meta: {
        title: '结题管理',
        icon: 'equiptype',
        requireAuth: true
      }
    }
  ]

}

export default equipRouter
